import {CtImage} from '../../models/ct-image';
import {CtImageSource} from '../../models/ct-image-source';
import {CtImageType} from '../../models/ct-image-type';

import {CtLocale} from '../../models/ct-locale';
import {CtLocaleContent} from '../../models/ct-locale-content';
import {CtLocaleKeyHints} from '../../models/ct-locale-hints';
import {CtLocaleKey} from '../../models/ct-locale-key';

import {CtPage} from '../../models/ct-page';
import {CtPageCategory} from '../../models/ct-page-category';
import {CtPageImage} from '../../models/ct-page-image';
import {CtPageUrl} from '../../models/ct-page-url';
import {LocaleHistory} from '../../models/locale-history';
import {Agent, request} from './base';

export class ColdTrafficAgent {
    page = new Agent(CtPage, '/cold-traffic/pages');
    pageUrls = new Agent(CtPageUrl, '/cold-traffic/pages/urls');
    pageImages = new Agent(CtPageImage, '/cold-traffic/pages/images');
    pageCategories = new Agent(CtPageCategory, '/cold-traffic/pages/categories');

    images = new Agent(CtImage, '/cold-traffic/images');
    imageTypes = new Agent(CtImageType, '/cold-traffic/images/types');
    imageSources = new Agent(CtImageSource, '/cold-traffic/images/sources');

    sync = async () => {
        return request.post('/cold-traffic/pages/sync', {});
    };

    getLocales = async ({pageId, motherLangId, targetLangId}: {
        pageId: number;
        motherLangId: number;
        targetLangId: number;
    }) => {
        const res = await request.get('/cold-traffic/locales', {
            pageId,
            motherLangId,
            targetLangId,
        }) as CtLocale[];
        return res.map(el => new CtLocale(el));
    };

    getSyncStatus = async () => {
        const res = await request.get('/cold-traffic/pages/sync');
        return res;
    };

    clonePage = (id: number, postfix: string) => {
        return request.post(`/cold-traffic/pages/clone/${id}`, { postfix });
    };

    getLocaleHistory = async (contentId: number) => {
        const res = await request.get('/locales/history/cold-traffic/' + contentId) as LocaleHistory[];
        return res.map(el => new LocaleHistory(el));
    };

    setOutdated = async (id: number) => {
        return request.patch(`/cold-traffic/locales/content/outdated/${id}`, {});
    };
    setOutdatedAll = async (keyId: number, pageId: number, exceptionId: number) => {
        return request.patch(`/cold-traffic/locales/content/outdated/${keyId}/${pageId}/${exceptionId}`, {});
    };

    localeKeys = new Agent(CtLocaleKey, '/cold-traffic/locales/keys');
    localeContent = new Agent(CtLocaleContent, '/cold-traffic/locales/content');
    localeKeyHints = new Agent(CtLocaleKeyHints, '/cold-traffic/locales/keys/hints');
}
